module.exports = __webpack_public_path__ + "166a2f016c3ca18fa243ede2a9d2d45c.png";